import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { getToken, getBiometricToken } from '@/helpers/http';

export default {
  state() {
    return {
      token: getToken(),
      biometricToken:getBiometricToken(), 
      refreshToken: null,
      infor: {},
      authenticationToken: sessionStorage.getItem('authenticationToken') || null,
      maximumAmount: sessionStorage.getItem('maximumAmount') || null,
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true
};
